import { render, staticRenderFns } from "./PersonCommunications.vue?vue&type=template&id=69dd11aa"
import script from "./PersonCommunications.vue?vue&type=script&lang=js"
export * from "./PersonCommunications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports